import { Badge, Text, Tooltip } from "@mantine/core"
import css from "./cells.module.css"
import { FormulaResult } from "../../../../../../@client/Theasoft_ApiServer_Orchestra"

export function FormulaContractCell({
  formulaSum: v,
  rowIndex,
}: {
  formulaSum?: FormulaResult
  rowIndex: number
}) {
  return (
    <div
      className={rowIndex % 2 === 0 ? css["even-row"] : css["odd-row"]}
      style={{
        display: "flex",
        justifyContent: "stretch",
        alignItems: "stretch",
      }}
    >
      {v?.value ? <FormulaResultBadge value={v} /> : null}
    </div>
  )
}

const FormulaResultBadge = ({ value }: { value: FormulaResult }) => (
  <Badge
    radius={0}
    flex="1"
    fullWidth
    h="100%"
    variant="light"
    bg={value.bg}
    p={0}
    c={value.c}
  >
    <Tooltip label={value.text} style={{ whiteSpace: "pre-line" }}>
      <Text size="xs">{value.value}</Text>
    </Tooltip>
  </Badge>
)
